/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M24 17.97c-3.31 0-6.013 2.669-6.013 6.013s2.669 6.013 6.013 6.013 5.979-2.703 5.979-6.013S27.31 17.97 24 17.97zm0 18.005c-3.31 0-6.013 2.668-6.013 6.012S20.656 48 24 48s6.013-2.669 6.013-6.013S27.31 35.975 24 35.975zm0-23.983c3.31 0 6.013-2.669 6.013-6.013S27.31 0 24 0s-6.013 2.669-6.013 6.013S20.69 11.992 24 11.992z"/>'
}
